import React from 'react';
import ControlPanel from '../common/ControlPanel';

const controls = [
  { key: 'system_onoff', label: 'System On/Off', type: 'toggle', reg: 1024 },
  { key: 'operating_mode', label: 'Operating Mode', type: 'select', reg: 1025, options: [
    { value: 0, label: 'Stop' },
    { value: 1, label: 'Cycle' },
    { value: 2, label: 'Cool' },
    { value: 3, label: 'Heat' },
    { value: 4, label: 'Auto' },
  ]},
  { key: 'temp_source', label: 'Temp Source', type: 'select', reg: 1026, options: [
    { value: 0, label: 'Source 0' },
    { value: 1, label: 'Source 1' },
    { value: 2, label: 'Source 2' },
    { value: 3, label: 'Source 3' },
  ]},
  { key: 'cool_setpoint', label: 'Cool Setpoint', type: 'number', reg: 58880, min: 5, max: 35, step: 0.5, unit: '°C', scale: 10 },
  { key: 'heat_setpoint', label: 'Heat Setpoint', type: 'number', reg: 58881, min: 5, max: 35, step: 0.5, unit: '°C', scale: 10 },
  { key: 'cool_sensitivity', label: 'Cool Sensitivity', type: 'number', reg: 58882, min: 1, max: 10, step: 0.5, unit: '°C', scale: 10 },
  { key: 'pump_gear', label: 'Pump Gear', type: 'select', reg: 58884, options: [
    { value: 0, label: '0 (Off)' },
    { value: 1, label: '1 (Low)' },
    { value: 2, label: '2 (Mid)' },
    { value: 3, label: '3 (High)' },
  ]},
  { key: 'compressor_gear', label: 'Compressor Gear', type: 'select', reg: 58888, options: [
    { value: 0, label: '0 (Off)' },
    { value: 1, label: '1 (Low)' },
    { value: 2, label: '2 (Mid)' },
    { value: 3, label: '3 (High)' },
  ]},
  { key: 'silent_mode', label: 'Silent Mode', type: 'toggle', reg: 58901 },
];

// chiller1 = addr 5, chiller2 = addr 6
const addrMap = { chiller1: '5', chiller2: '6' };

function buildDesired(values, chiller) {
  const addr = addrMap[chiller];
  const desired = { chiller: { [addr]: { cmd: {} } } };
  for (const [key, value] of Object.entries(values)) {
    const ctrl = controls.find(c => c.key === key);
    if (!ctrl) continue;
    const scaledValue = ctrl.scale ? Math.round(value * ctrl.scale) : value;
    desired.chiller[addr].cmd[key] = { reg: ctrl.reg, value: scaledValue };
  }
  return desired;
}

export default function ChillerControlPanel({ chiller = 'chiller1' }) {
  return (
    <ControlPanel
      title={`${chiller.replace('chiller', 'Chiller ')} Controls (addr ${addrMap[chiller]})`}
      controls={controls}
      buildDesired={(values) => buildDesired(values, chiller)}
    />
  );
}
